import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from "react";
import sift from "sift";
import classnames from "classnames";
import config from "../../../../config";
import withUserMenu from "../../../UserMenu/UserMenu.store";
import Button from "../../../Button";
import styles from "./CompareButton.module.scss";

var isUserMenuEnabled = config.userCustomisationMenu.get("enabled"),
    CompareButtonComponent = function CompareButtonComponent(a) {
  var b,
      c = a.size,
      d = a.className,
      e = a.pkg,
      f = a.userMenu,
      g = a.packageLink,
      h = a.onViewClick,
      i = a.onlyCompare,
      j = a.onlyView,
      k = _slicedToArray(f, 2),
      l = k[0],
      m = k[1],
      n = l.compare,
      o = n.find(sift({
    slug: e.slug
  }));

  return /*#__PURE__*/React.createElement("div", {
    className: classnames("ta-btn", d, styles.wrapper, (b = {}, _defineProperty(b, styles.isBeingCompared, o), _defineProperty(b, styles.onlyCompare, i), _defineProperty(b, styles.onlyView, j), _defineProperty(b, "ta-btn__".concat(c), c), b))
  }, isUserMenuEnabled ? /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    size: c,
    className: styles.compare,
    onClick: function onClick() {
      o ? m.removeCompare(e.slug) : m.addCompare(e);
    }
  }, o ? "\u2014" : "Compare") : null, /*#__PURE__*/React.createElement(Button, {
    href: g,
    color: "secondary",
    size: c,
    className: styles.view,
    onClick: h
  }, "View"));
};

export var CompareButton = withUserMenu(CompareButtonComponent);
export default CompareButton;